import { type NuxtAppConfig } from 'nuxt/schema'

export default defineNuxtPlugin(() => {
  const headConfig: NuxtAppConfig['head'] = {
    meta: [],
    script: [],
  }

  const { isMobile } = useDevice()

  if (isMobile) {
    headConfig.meta = [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
      },
      {
        name: 'applicable-device',
        content: 'mobile',
      },
      {
        name: 'force-rendering',
        content: 'webkit',
      },
      {
        name: 'apple-mobile-web-app-capable',
        content: 'yes',
      },
      {
        name: 'full-screen',
        content: 'true',
      },
      {
        name: 'screen-orientation',
        content: 'portrait',
      },
      {
        name: 'x5-fullscreen',
        content: 'true',
      },
      {
        name: '360-fullscreen',
        content: 'true',
      },
      {
        name: 'apple-mobile-web-app-capable',
        content: 'yes',
      },
      {
        name: 'apple-mobile-web-app-status-bar-style',
        content: 'black',
      },
      {
        name: 'format-detection',
        content: 'telephone=no',
      },
    ]
    headConfig.script!.unshift({
      innerHTML:
        '!function(){var e=null,t=document.documentElement;function n(){e=Math.ceil(100*(e=t.offsetWidth/7.5))/100,t.style.fontSize=e+"px";var n=window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.replace("px","");e!==n&&(t.style.fontSize=e*(e/n)+"px")}n(),window.addEventListener("resize",n)}();',
    })
  } else {
    headConfig.script!.unshift({
      innerHTML:
        // '!function(){var e=null,t=document.documentElement;function n(){var n=t.offsetWidth;e=Math.ceil(100*(e=n>=1920?123:n<=1560?100:n/15.6))/100,t.style.fontSize=e+"px";var l=window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.replace("px","");e!==l&&(t.style.fontSize=e*(e/l)+"px")}n(),window.addEventListener("resize",n)}();',
        '!function(){var e=null,t=document.documentElement;function n(){var n=t.offsetWidth;e=Math.ceil(100*(e=n<=1560?100:n/15.6))/100,t.style.fontSize=e+"px";var l=window.getComputedStyle(document.getElementsByTagName("html")[0]).fontSize.replace("px","");e!==l&&(t.style.fontSize=e*(e/l)+"px")}n(),window.addEventListener("resize",n)}();',
    })
  }

  useHead(headConfig, { tagPriority: 'critical' })
})
